import EpgPersistence from '../Nepg/EpgPersistence';
import EventTimeshift from '../Timeshift/EventTimeshift';
import MultipleLangLive from '../LanguageLive/MultipleLangLive';
import EnableSpinner from '../Spinner/EnableSpinner';
import LoadingIptvOttFlow from './LoadingIptvOttFlow';
import ShakaLib from '../../devices/all/shakaPlayer/ShakaLib';
import AAF from '../AAF';
import LoadPtv from './LoadPtv';

const init = function() {
  try {
    // CARGA DE LLAVE PARA VALIDAD IPTV SIN MEDIO DE PAGO, POR MEDIO DE AUTHDEVICE
    LoadPtv.init();
    // CARGA DE NUEVA EXPERIENCIA EPG
    EpgPersistence.init();

    // CARGA SYNC DE LOS LEVELS PARA IPTV.
    LoadingIptvOttFlow.init();

    // Inicializar valor de delay ch up ch down en miniepg
    EpgPersistence.getDelayChangeChannel();

    // CARGA DE NUEVA EXPERIENCIA TIMESHIFT
    EventTimeshift.init();

    // CARGA DE MULTIPLES AUDIO EN LIVE
    MultipleLangLive.initialize();

    // CARGA PARA MOSTRAR O NO EL SPINNER EN LIVE
    EnableSpinner.init();

    // Enable/disable shaka debug mode
    ShakaLib.init();

    // AAF
    AAF.Timeshift.initPlayerWaterMark();
  } catch (e) {}
};

const LoadExperience = {
  init
};

export default LoadExperience;



// WEBPACK FOOTER //
// ./src/AAF/LoaderExp/LoadExperience.js